import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function Podium() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const locale = useSelector((state) => state.locale.locale);

  useEffect(() => {
    setData(t("home.podium", { returnObjects: true }));
  }, [t, locale]);
  return (
    <div className="w-full bg-categoryPodium relative bg-center bg-cover bg-no-repeat min-h-[50rem]">
      <div className="absolute bg-graphicPrize2026Bottom w-full h-full bg-bottom bg-cover opacity-100"></div>
      <div className="container mx-auto text-center font-ttFirsNeue text-white py-24 space-y-10 relative">
        <h1 className="uppercase italic font-bold 2xl:text-5xl text-3xl font-soulmaze">
          {data?.title}
        </h1>
        <div className="w-full flex items-center justify-center">
          <div className="grid lg:grid-cols-4 gap-10 w-5/6">
            {data?.data.map((value, index) => (
              <div className=" rounded-lg" key={value.title}>
                <div className="2xl:py-14 lg:py-10 py-7 bg-black/30 backdrop-blur-xl text-center rounded-t-lg">
                  <h1 className="font-bold 2xl:text-2xl text-xl">
                    {value.title}
                  </h1>
                </div>
                <div className="bg-neutral-950 2xl:py-10 py-8 lg:py-5 px-10 rounded-b-lg font-light h-30 lg:h-60">
                  <p dangerouslySetInnerHTML={{ __html: value.desc }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
